import type { QueryClient } from "@tanstack/react-query"
import { redirect } from "@tanstack/react-router"

import type { PermissionKey } from "@optimist/schemas"
import { portalAuthQueryOptions } from "@/features/authz/hooks/use-portal-auth"

export async function requirePermissionRouteAccess(
	queryClient: QueryClient,
	permission: PermissionKey | readonly PermissionKey[],
): Promise<void> {
	const auth = await queryClient.ensureQueryData(portalAuthQueryOptions)
	const permissions = typeof permission === "string" ? [permission] : permission
	if (!permissions.some((key) => auth.permissions.includes(key))) {
		throw redirect({ to: "/dashboard" })
	}
}
